// extracted by mini-css-extract-plugin
export default {"uploadedDocument":"DocumentView_uploadedDocument__OxXHh","numberPages":"DocumentView_numberPages__MvH1+","btnPage":"DocumentView_btnPage__a9oQx"};